// extracted by mini-css-extract-plugin
module.exports = {"popularSearchesInnerContainer":"az_rbb","popularSearchesOuterContainer":"az_sbb","popularSearchHeading":"az_tbb","popularSearchLink":"az_ubb"};